import React, { Component, Suspense } from "react";
import Loadable from "react-loadable";
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import "../../node_modules/font-awesome/scss/font-awesome.scss";
import { AuthContext } from "../context/auth";
import Aux from "../hoc/_Aux";
import routes from "../route";
import fetchLoggedInUser from "../store/fetch/fetchUserProfile";
import PrivateRoute from "./components/PrivateRoute";
import ScrollTopButton from "./components/ScrollTopButton";
import Loader from "./layout/Loader";
import ScrollToTop from "./layout/ScrollToTop";



const AdminLayout = Loadable({
  loader: () => import("./layout/AdminLayout"),
  loading: Loader,
});

class App extends Component {
  constructor(props) {
    super(props);
    const authToken = localStorage.getItem("authToken");
    this.state = {
      authToken,
    };
  }

  componentDidMount = () => {
    const { fetchProfile } = this.props;
    if (this.state.authToken) {
      fetchProfile();
    }
  }

  setAuthToken = (token) => {
    if (token) {
      localStorage.setItem("authToken", token.access_token);
      this.setState({
        authToken: token.access_token,
      });
    } else {
      localStorage.removeItem("authToken");
      localStorage.removeItem("token");
      localStorage.removeItem("actionTime");
      localStorage.removeItem("actionTimeEnd");
      this.setState({
        authToken: null,
      });
    }
  };

  render() {
    const menu = routes.map((route, index) => {
      return route.component ? (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          name={route.name}
          render={(props) => <route.component {...props} />}
        />
      ) : null;
    });

    return (
      <Aux>
        <AuthContext.Provider
          value={{
            authToken: this.state.authToken,
            setAuthToken: this.setAuthToken,
          }}
        >
          <ScrollToTop>
            <Suspense fallback={<Loader />}>
              <Switch>
                {menu}
                <PrivateRoute path="/" component={AdminLayout} />
              </Switch>
            </Suspense>
          </ScrollToTop>
          <ScrollTopButton scrollStepInPx="50" delayInMs="16.66" />
        </AuthContext.Provider>
      </Aux>
    );
  }
}


const mapDispatchToProps = dispatch => bindActionCreators({
  fetchProfile: fetchLoggedInUser
}, dispatch);

export default withRouter(connect(
  null,
  mapDispatchToProps
)(App));